import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { initFirebaseBackend } from './authUtils';
import { FileUploadModule } from 'primeng/fileupload';

import { FakeBackendInterceptor } from './core/helpers/fake-backend';
import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { NgxChartsModule} from '@swimlane/ngx-charts';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule, NgbTooltipModule, NgbPopoverModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { LayoutsModule } from './layouts/layouts.module';
import { PagesModule } from './pages/pages.module';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { initializeKeycloak } from './account/auth/app.init';
import { FieldInfoGridService } from './pages/field-info-grid/field-info-grid.service';
import { helperService } from './utils/helper';

if (environment.defaultauth === 'firebase') {
  initFirebaseBackend(environment.firebaseConfig);
} else {
  FakeBackendInterceptor;
}
export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [TranslateModule.forRoot({
            defaultLanguage: 'en',
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        BrowserModule,
        AppRoutingModule,
        PagesModule,
        NgbModule,
        NgbTooltipModule,
        NgbPopoverModule,
        NgbNavModule,
        BrowserAnimationsModule,
        LayoutsModule,
        TranslateModule,
        KeycloakAngularModule,
        FileUploadModule,
        NgxChartsModule], providers: [
        FieldInfoGridService,
        {
            provide: APP_INITIALIZER,
            // Run all startup data loads AFTER keycloak finishes authenticating, so the bearer
            // token exists when these requests fire (running them as parallel APP_INITIALIZERs
            // raced keycloak.init -> no Authorization header -> 401). loadUserRoles stays
            // non-blocking (called, not awaited). fetchAllFieldsOnce is awaited so its cache is
            // ready before first render, BUT its failure is CAUGHT so a backend error on that
            // single endpoint cannot reject the initializer and blank the whole app -- the app
            // still bootstraps and grid fields simply stay empty (and retry on next call,
            // since _fieldsLoaded is left false) until the endpoint recovers.
            useFactory: (keycloak: KeycloakService, fieldInfoService: FieldInfoGridService, helper: helperService) =>
                () => initializeKeycloak(keycloak)().then(() => {
                    helper.loadUserRoles();
                    return fieldInfoService.fetchAllFieldsOnce().catch((err) => {
                        console.error('Startup grid-fields load failed; continuing without preloaded fields.', err);
                        return [];
                    });
                }),
            multi: true,
            deps: [KeycloakService, FieldInfoGridService, helperService]
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
